import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=78dac83c&scoped=true"
import script from "./Template4.vue?vue&type=script&lang=js"
export * from "./Template4.vue?vue&type=script&lang=js"
import style0 from "./Template4.vue?vue&type=style&index=0&id=78dac83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dac83c",
  null
  
)

export default component.exports